const OverlandExpress = () => {
    return (
      <div>
          <div className="">
            <img src="/LogisticsBanner/banner-1.jpg" width="100%"/>
          </div>
        <div className="flex flex-col justify-center items-center mb-[1.5rem]">
        <hr className="w-[52rem]"/>
          <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5 ">
          
            <div className="flex flex-col justify-center">
              <h1 className="font-bold text-3xl text-[#373737]">
                Overland Express
              </h1>
              <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                Formed in 1989, TCS is the market leader in door-to-door goods transportation business 
                in Pakistan. This business is particularly suited for your bulk cargo movements to around 
                200 cities of the country, with 38–72 hours transit time.
              </p>
              <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                TCS Overland Express is the preferred of a large corporate customer base when it comes 
                to secured, economical and time definite transportation of heavy cargo shipments to any part 
                of the country. Our large customer base includes: Pharmaceutical companies, Banking sector, 
                Major printing houses, Automotive industries, Cellular industry.
              </p>
              <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                Due to having our own warehouses and, one of the largest company-owned fleet in Pakistan and a perfect 
                Fleet Integrated Management System, we are able to have full control of cold chain logistics—from origin 
                to destination, including Temperature controlled transport and Storage, Distribution, LTL & FTL services, 
                Door to Door services, Live Track & Trace through data loggers
              </p>
            </div>
            <div className="flex-1 flex flex-col justify-center items-center">
              <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
            </div>
          </div>
      
        </div>
      </div>
    );
  };
  
  export default OverlandExpress;
  